import Component from '@glimmer/component';
import { action } from '@ember/object';
import fade from 'ember-animated/transitions/fade';

export default class DeluxePlayerNowPlayingComponent extends Component {
  @action
  checkOverflow(e) {
    let element = e?.target || this.element;
    if (!element) {
      return;
    }

    element.querySelectorAll('[data-check-overflow]').forEach((el) => {
      if (el.scrollWidth > element.getBoundingClientRect().width) {
        el.classList.add('has-overflow');
      } else {
        el.classList.remove('has-overflow');
      }
    });
  }

  rules({ oldItems, newItems }) {
    return fade;
  }

  transition = fade;
  element = null;

  @action
  didInsert(element) {
    this.element = element;
  }
}
